var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragHandleRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.75H3.75C3.3375 6.75 3 7.0875 3 7.5C3 7.9125 3.3375 8.25 3.75 8.25H14.25C14.6625 8.25 15 7.9125 15 7.5C15 7.0875 14.6625 6.75 14.25 6.75ZM3.75 11.25H14.25C14.6625 11.25 15 10.9125 15 10.5C15 10.0875 14.6625 9.75 14.25 9.75H3.75C3.3375 9.75 3 10.0875 3 10.5C3 10.9125 3.3375 11.25 3.75 11.25Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandleRounded);
export default __webpack_public_path__ + "static/media/DragHandleRounded.7ccf1fc2aaeffd927a409ad29e9f2188.svg";
export { ForwardRef as ReactComponent };